import React, {useCallback, useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@material-ui/core';

import Context from 'utils/Context';
import ModalPlayerVod from 'components/ModalPlayerVod';
import VODPaymentModal from 'components/VODPayment';

const CuultRenting = ({vod, rental, cinemaId, onSuccess}) => {
  const {t} = useTranslation();
  const {appState} = useContext(Context);

  const [vodModalOpen, setVodModalOpen] = useState(false);
  const [paymentOpen, setPaymentOpen] = useState('waitingPaymentConfirmation' in appState.query || false);

  const handleSuccess = useCallback(
    data => {
      onSuccess(data);
      setPaymentOpen(false);
    },
    [onSuccess],
  );

  const handleClick = () => {
    if (rental) {
      setVodModalOpen(true);
      return;
    }
    setPaymentOpen(true);
    return;
  };

  const handleClosePayment = useCallback(() => setPaymentOpen(false), []);

  return (
    <div className="FilmSchedule-container">
      <Button onClick={handleClick} className="rent-button">
        {t(rental ? 'voir-le-film' : 'louer-en-vod')}
      </Button>
      {vodModalOpen && <ModalPlayerVod rental={rental} vod={vod} onClose={() => setVodModalOpen(false)} />}
      {paymentOpen && (
        <VODPaymentModal cinemaId={cinemaId} vod={vod} onClose={handleClosePayment} onSuccess={handleSuccess} />
      )}
    </div>
  );
};

export default CuultRenting;
